import { render } from "./BasicBar.vue?vue&type=template&id=73727024"
import script from "./BasicBar.vue?vue&type=script&lang=js"
export * from "./BasicBar.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/omniauto/omninext/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__